import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import ImpressaoGif from '../../../assets/gif/impressao_gif.gif';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Box } from '../../../components/UI-CHAKRA/Box';
import styled, { keyframes } from 'styled-components';
import { useState } from 'react';

interface DialogRetainSignPrescriptionProps {
  onProceed: () => void;
  onIgnore: () => void;
}

export const DialogRetainSignPrescription = ({ onProceed, onIgnore }: DialogRetainSignPrescriptionProps) => {
  const [gifLoaded, setGifLoaded] = useState(false);

  return (
    <Flex
      flexWrap="wrap"
      height="100%"
      maxHeight="100%"
      overflowY={{ base: 'scroll', md: 'unset' }}
      gap={{ base: '20px', md: 0 }}
    >
      <Flex width={{ base: '100%', md: '60%' }} flexDirection="column" gap="10px" justifyContent="center">
        <Text color="gray.900" fontSize="18px" fontWeight={700}>
          Não precisa imprimir!
        </Text>
        <Text fontSize="14px" color="gray.900">
          Instrua seus pacientes a abrirem a receita através do <b>link</b> que chegará <b>pelo celular</b>.
        </Text>
        <Flex pl="20px">
          <Text fontSize="14px" color="gray.900">
            <ul style={{ listStyle: 'disc' }}>
              <li>Receita médica sempre a mão;</li>
              <li>É possível efetuar a compra online de qualquer lugar do Brasil;</li>
              <li>A receita digital é aceita em qualquer farmácia do país;</li>
              <li>O paciente consegue baixar o PDF pelo link.</li>
            </ul>
          </Text>
        </Flex>
      </Flex>
      <Flex width={{ base: '100%', md: '40%' }} position="relative">
        <GifLoader opacity={gifLoaded ? 0 : 1} transition="1s all" />
        <img
          src={ImpressaoGif}
          alt="Mevo Saúde"
          style={{ transition: '1s all', opacity: gifLoaded ? 1 : 0 }}
          onLoad={() => setGifLoaded(true)}
        />
      </Flex>
      <Flex
        width="100%"
        mt="10px"
        gap={{ base: '20px', md: '0' }}
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ base: 'column', md: 'row' }}
      >
        <Button
          width={{ base: '100%', md: 'auto' }}
          variant="outline"
          color="#FF6161"
          borderColor="#FF6161"
          borderRadius="20px"
          fontSize="14px"
          onClick={onIgnore}
        >
          Ignorar benefícios
        </Button>
        <Button
          width={{ base: '100%', md: 'auto' }}
          variant="solid"
          color="white"
          bgColor="green.300"
          borderRadius="20px"
          fontSize="14px"
          onClick={onProceed}
        >
          Enviar somente digital
        </Button>
      </Flex>
    </Flex>
  );
};

const GifLoaderAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const GifLoader = styled(Box)`
  position: absolute;
  border-radius: 20px;
  margin-left: 10px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-image: linear-gradient(-45deg, #dee2e6 0%, #dee2e6 25%, #dee2e6 51%, #adb5bd 100%);
  background-size: 300% 200%;
  animation: ${GifLoaderAnimation} 4s alternate infinite;
`;
